module.exports = __webpack_public_path__ + "static/img/media_title.b3c094c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media_title.jpg
// module id = vhEa
// module chunks = 1